import axiosClient from './axiosClient';
import {
  IAlertStatic,
  IInstallationLocationItem,
  IListAlert,
  IOverview,
  IStatistic,
} from '~/utils/interface/dashboard';

const dashboardApi = {
  getOverviewData() {
    const url = `/api/dashboard/over-view`;
    return axiosClient.get<IOverview>(url);
  },

  getListAlert() {
    const url = `/api/dashboard/list-alert`;
    return axiosClient.get<IListAlert[]>(url);
  },

  getListInstallationLocation() {
    const url = `/api/dashboard/list-installation-location`;
    return axiosClient.get<IInstallationLocationItem[]>(url);
  },

  getAlertStatistic24h() {
    const url = `/api/dashboard/alert-statistic-24h`;
    return axiosClient.get<IAlertStatic[]>(url);
  },

  getStatisticData() {
    const url = `/api/dashboard/statistic`;
    return axiosClient.get<IStatistic>(url);
  },
};

export default dashboardApi;
